// extracted by mini-css-extract-plugin
module.exports = {"deleted":"Search_deleted_olTdS","holder":"Search_holder_VsUn1"};